var map = {
	"./16-0-8.pdf": 4358,
	"./ADAMSEARTH.pdf": 4623,
	"./BLACKSTRAP.pdf": 4754,
	"./BlackStone24.pdf": 3829,
	"./OMEGAX34.pdf": 3645,
	"./impulse.pdf": 5880,
	"./kelplant.pdf": 364,
	"./sugarCal.pdf": 4677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4525;